/**
 * Timings shared by every trigger-driven assessment screen.
 *
 * These were declared separately in formativeScreenConstants.js,
 * formativeMultipleChoiceConstants.js, SentenceBuilder.js and BlendingSelection.js, with the same
 * values in each. The idle pair kept beside them had already drifted apart by 4s and 30s, which
 * gave a child a different auto-submit window depending on which item type they were on, so
 * these live in one place now. The legacy ModularMultipleChoice keeps its own copy because it
 * is frozen at Release 9.17.2026.
 */

/** How long a [click:<target>] pointer rests on its target before the trigger completes. */
export const HIGHLIGHT_DURATION = 2000;

/** Replay ceiling for a stimulus video or image, before the item's own authored cap applies. */
export const MAX_REPLAYS = 5;

/** Pause between tiles while a pool or option list narrates itself one at a time. */
export const TIME_BETWEEN_OPTIONS = 1000;

/** The same pause when nothing is read aloud, where the gap is dead time in front of the answer. */
export const TIME_BETWEEN_SILENT_OPTIONS = TIME_BETWEEN_OPTIONS / 4;
